import { Pipe, PipeTransform } from '@angular/core';
import { ContentInterface, ContentService } from 'outshared-lib';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

/** @deprecated - this is moved to libs */
@Pipe({
    name: 'element',
    pure: false,
})
export class ElementPipe implements PipeTransform {

    constructor(private contentService: ContentService) { }

    transform(value: string | number, name: string): Observable<string | number> {
        return this.contentService.getContentById$(name, String(value)).pipe(
            take(1),
            map((element: ContentInterface) => element.content_description),
        );
    }
}
